import type { Config, Data } from "@measured/puck";

import Page from "@/components/puck/Page";

/*
 * Renamed components
 *
 * Divider > Rule
 *
 */

import { Button, ButtonProps } from "./blocks/Button";
import { Flex, FlexProps } from "./blocks/Flex";
import { Space, SpaceProps } from "./blocks/Space";
import { Grid, GridProps } from "./blocks/Grid";
import { Text, TextProps } from "./blocks/Text";
import { Heading, HeadingProps } from "./blocks/Heading";
import { Graph, GraphProps } from "./blocks/Graph";
import { DataBlock, DataProps } from "./blocks/DataBlock";
import { DataTable, DataTableProps } from "./blocks/DataTable";
import PageIconSelector from "@/components/puck/PageIconSelector";
import PageCategorySelector from "@/components/puck/PageCategorySelector";

export type Props = {
  Button: ButtonProps;
  Flex: FlexProps;
  Space: SpaceProps;
  Grid: GridProps;
  Text: TextProps;
  Heading: HeadingProps;
  Graph: GraphProps;
  DataBlock: DataProps;
  DataTable: DataTableProps;
};

export type UserData = Data<Props, any>;

export const config: Config<Props, any> = {
  categories: {
    layout: {
      components: ["Grid", "Flex", "Space"],
    },
    typography: {
      components: ["Heading", "Text"],
    },
    interactive: {
      title: "Actions",
      components: ["Button"],
    },
    data: {
      components: ["DataBlock", "Graph", "DataTable"],
    },
  },
  components: {
    Button,
    Flex,
    Space,
    Grid,
    Text,
    Heading,
    Graph,
    DataBlock,
    DataTable,
  },
  root: {
    defaultProps: {
      title: "",
      icon: "layout-dashboard",
      category_id: null,
    },
    fields: {
      title: {
        type: "text",
      },
      icon: {
        type: "custom",
        render: ({ value, onChange }) => {
          return <PageIconSelector value={value} onChange={onChange} />;
        },
      },
      category_id: {
        type: "custom",
        render: ({ value, onChange }) => {
          return <PageCategorySelector value={value} onChange={onChange} />;
        },
      },
    },
    render: ({ puck }) => {
      return (
        <Page puck={puck}>
          {puck.renderDropZone({
            disallow: ["GridItem"],
            zone: "default-zone",
          })}
        </Page>
      );
    },
  },
};
